export enum SocialTypes {
  FACEBOOK = "facebook",
  TWITTER = "twitter",
  LINKEDIN = "linkedin",
  INSTAGRAM = "instagram",
  OTHER = "other",
}

export type SocialLinkDto = {
  type: SocialTypes;
  is_public: boolean;
  url: string;
};

export type T_Testimonials = {
  _id: string;
  rating: number;
  review: string;
  customer_name: string;
  company_name: string;
  social_links: SocialLinkDto[];
  company_position: string;
  image: string;
};
